module.exports = __webpack_public_path__ + "img/dribble-girl.2caeef42.svg";